<template>
  <div :class="['added-accessory-card', { 'is-base': !action }]">
    <div class="card-left">
      <div class="badge-row" v-if="!action">
        <span class="base-model-badge">Base Unit</span>
      </div>
      <div class="accessory-title-text">{{ title }}</div>
      <div class="accessory-subtitle-text">{{ subtitle }}</div>
    </div>
    <div class="card-right" v-if="action">
      <Tooltip text="Remove accessory" location="left">
        <v-btn
          icon="mdi-trash-can-outline"
          variant="text"
          color="error"
          size="small"
          class="remove-accessory-btn"
          @click="$emit('remove')"
        />
      </Tooltip>
    </div>
  </div>
</template>

<script setup lang="ts">
import Tooltip from "@/components/typography/Tooltip.vue";

defineProps<{
  title: string
  subtitle: string
  action?: boolean
}>()

defineEmits<{
  (e: 'remove'): void
}>()
</script>

<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

.added-accessory-card {
  font-family: 'Inter', sans-serif;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  border: 1px solid #f3f4f6;
  border-radius: 12px;
  padding: 12px 16px;
  margin: 8px 12px;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);

  &:hover {
    border-color: #e5e7eb;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
    background: #fafafa;
  }

  &.is-base {
    background: #f9fafb;
    border-left: 4px solid #10b981;
    border-radius: 8px 12px 12px 8px;
    
    &:hover {
      background: #f3f4f6;
    }
  }
}

.card-left {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}

.badge-row {
  margin-bottom: 2px;
}

.base-model-badge {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  background: #e6f4ea;
  color: #137333;
  padding: 2px 6px;
  border-radius: 4px;
  display: inline-block;
}

.accessory-title-text {
  font-size: 13px;
  font-weight: 500;
  color: #1f2937;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.accessory-subtitle-text {
  font-size: 11px;
  font-weight: 400;
  color: #9ca3af;
}

.card-right {
  display: flex;
  align-items: center;
  margin-left: 8px;
}

.remove-accessory-btn {
  opacity: 0.6;
  transition: opacity 0.2s ease, transform 0.2s ease;

  &:hover {
    opacity: 1;
    transform: scale(1.05);
  }
}

/* Dark Theme support */
.dark-theme .added-accessory-card,
.dark .added-accessory-card {
  background: #1a1a26;
  border-color: #2b2b3d;

  &:hover {
    background: #222232;
    border-color: #3b3b55;
  }

  &.is-base {
    background: #1e1e2d;
    border-left-color: #10b981;
    
    &:hover {
      background: #252538;
    }
  }

  .accessory-title-text {
    color: #f3f4f6;
  }

  .accessory-subtitle-text {
    color: #6b7280;
  }

  .base-model-badge {
    background: rgba(16, 185, 129, 0.15);
    color: #34d399;
  }
}
</style>
